import React from 'react';
import './SurveyResponsesResponseDetail.css';
import logComponent from '../../common/logComponent';
import { format, parseISO } from 'date-fns';
import GraphicalIcon from '../GraphicalIcon/GraphicalIcon';

export default function SurveyResponsesDetail({ surveyResponse, fullWidth, onGoBackClick }) {

  if (logComponent('SurveyResponsesResponseDetail')) { console.debug('SurveyResponsesResponseDetail rendered'); }


  const handleClick = () => {
    if (logComponent('SurveyResponsesSurveyCard')) { console.debug('SurveyResponsesSurveyCard handleClick'); }
    onGoBackClick();
  }

  return (
    surveyResponse &&
    <div className={'Survey-Responses-Response-Detail' + (fullWidth ? ' Survey-Responses-Response-Detail--full-width' : '')}>
      <div className={'Survey-Responses-Response-Detail__main'}>
        <div className={'Survey-Responses-Response-Detail__response-on'}>
          <p className="Survey-Responses-Response-Detail__label">Response on:</p>
          <p className="Survey-Responses-Response-Detail__date">{`${format(parseISO(surveyResponse.localStartOn), 'MM/dd/yyyy h:mm aa')}`}</p>
        </div>
        <p className="Survey-Responses-Response-Detail__score">{`Score: ${surveyResponse.score}`}</p>
        {
          !fullWidth && surveyResponse.surveyQuestionResponses
            .filter(surveyQuestionResponse => !surveyQuestionResponse.isCheckInSurveyFamilyNoteQuestion && !surveyQuestionResponse.isCheckInSurveyInternalNoteQuestion)
            .map(item =>
              <div className={'Survey-Responses-Response-Detail__question-response'} key={item.surveyQuestionResponseId}>
                <p className="Survey-Responses-Response-Detail__label">{`${item.questionText}`}</p>
                {item.optionAnswers && item.optionAnswers.length > 0 &&
                  item.optionAnswers.map(option =>
                    <p className="Survey-Responses-Response-Detail__answer" key={option.surveyQuestionOptionId}>
                      <React.Fragment>
                        {
                          !option.hasImage && !option.optionText && option.optionValue && <span>{option.optionValue}</span>
                        }
                        {
                          option.hasImage &&
                          <GraphicalIcon
                            url={option.optionUrl}
                            alt='Option Image'
                            svg={option.optionSvg}
                          />
                        }
                        {
                          option.optionText && <span>{option.optionText}</span>
                        }
                      </React.Fragment>
                    </p>
                  )
                }
                {
                  !item.optionAnswers || item.optionAnswers.length === 0 &&
                  <p className="Survey-Responses-Response-Detail__answer">{`${item.answer == null || item.answer == '' ? 'Not answered' : item.answer}`}</p>
                }

              </div>
            )
        }
          {
            fullWidth && surveyResponse.surveyQuestionResponses
              .map(item =>
                <div className={'Survey-Responses-Response-Detail__question-response'} key={item.surveyQuestionResponseId}>
                  <p className="Survey-Responses-Response-Detail__label">{`${item.questionText}`}</p>
                  {item.optionAnswers && item.optionAnswers.length > 0 &&
                    item.optionAnswers.map(option =>
                      <p className="Survey-Responses-Response-Detail__answer" key={option.surveyQuestionOptionId}>
                        <React.Fragment>
                          {
                            !option.hasImage && !option.optionText && option.optionValue && <span>{option.optionValue}</span>
                          }
                          {
                            option.hasImage &&
                            <GraphicalIcon
                              url={option.optionUrl}
                              alt='Option Image'
                              svg={option.optionSvg}
                            />
                          }
                          {
                            option.optionText && <span>{option.optionText}</span>
                          }
                        </React.Fragment>
                      </p>
                    )
                  }
                  {
                    !item.optionAnswers || item.optionAnswers.length === 0 &&
                    <p className="Survey-Responses-Response-Detail__answer">{`${item.answer == null || item.answer == '' ? 'Not answered' : item.answer}`}</p>
                  }

                </div>
              )
          }

      </div>
      {!fullWidth &&
        <div className={'Survey-Responses-Response-Detail__notes'}>
          {
            surveyResponse.surveyQuestionResponses
              .filter(surveyQuestionResponse => surveyQuestionResponse.isCheckInSurveyFamilyNoteQuestion || surveyQuestionResponse.isCheckInSurveyInternalNoteQuestion)
              .map(item =>
                <div className={'Survey-Responses-Response-Detail__question-response'} key={item.surveyQuestionResponseId}>
                  <p className="Survey-Responses-Response-Detail__label">{`${item.questionText}`}</p>
                  <p className="Survey-Responses-Response-Detail__answer">{`${item.answer == null || item.answer == '' ? 'Not answered' : item.answer}`}</p>
                </div>
              )


          }
          <button
            className="Survey-Responses__back-summary-button"
            onClick={handleClick} >
            Back
          </button>

        </div>
      }
    </div>
  );
}